import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAppsAsync } from '../redux/reducer/apps/appSlice';
import AppsList from './components/AppList';
import AppModal from './components/AppModal';
import { Box, Typography, Container } from '@mui/material';

const Home = () => {
  const dispatch = useDispatch();
  const userRole = localStorage.getItem('userRole');
  
  useEffect(() => {
    // Fetch apps only once when component mounts
    dispatch(fetchAppsAsync());
  }, [dispatch]);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default', py: 4 }}>
      <Container maxWidth="xl">
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h4"
            fontWeight="700"
            gutterBottom
            sx={{
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Applications
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage and monitor your educational applications
          </Typography>
        </Box>

        {/* Add App Modal - Only for admins */}
        {userRole === 'admin' && <AppModal />}

        {/* Apps List */}
        <AppsList />
      </Container>
    </Box>
  );
};

export default Home;
